import React, { useEffect, useState } from 'react';
import TermLengthStackedButton from '../TermLengthCalculator/TermLengthStackedButton';
import HealthClassCalcStackedButton from '../HealthClassCalculator/HealthClassCalcStackedButton';
import NeedsAnalysisStackedButton from '../../../Tools/NeedsAnalysis/NeedsAnalysisStackedButton';
import HealthClass from "./HealthClass";
import Age from '../../../Helpers/Dates/Age';

export default function TermInsuranceTools(props) {

  const getHealthClassNameFromCode = (hcCode) => {
    const healthClassMap = HealthClass();
    const currentHealthClass = healthClassMap.find((hc) => hc.value === hcCode.toUpperCase());
    return currentHealthClass.label;
  }

  return (
    <div className="tools-container">
      <h2 className="tools-title">Insurance Tools</h2>
      <div className="insurance-tools-container">
          <NeedsAnalysisStackedButton
            type="quote-screen"
            minCoverageAmount={25000}
            maxCoverageAmount={1500000}
            setCoverageAmount={(face) => {
              props.setCoverageAmount(face);
            }}
            toolName="Coverage Amount Calculator"
            title="How much do I need?"
            isCustomTerm={true}
          />

        
          <TermLengthStackedButton
            type='quote-screen'
            toolName="Term Length Calculator"
            title="Choose a term length"
            isCustomTerm={true}
            insuredAge={Age(props.basicInfo.birthdate)}
            onTermLengthCalculation={(suggestedTermlength) => {
              props.setTermLength(suggestedTermlength);
            }}
          />

          <HealthClassCalcStackedButton
            type='quote-screen'
            toolName="Health Rating Calculator"
            title="Confirm my health rating"
            currentHealthClass={getHealthClassNameFromCode(props.healthClass)}
            onHealthClassChange={props.onHealthClassChange}
          />
      </div>
    </div>
  );
}
